import { Backdrop, CircularProgress, Grid, Paper, styled } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import * as React from 'react';
import { memo, useEffect, useState } from 'react';
import apiConfig from 'src/api/APIConfig';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import './MilestoneTracking.scss';
import { store } from 'src/store';
import moment from 'moment';
import { showLoader,hideLoader } from 'src/store/Loader';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

const AssociatedDocuments: React.FunctionComponent<any> = ({ selectedMilestone, studyId, siteId, country }) => {
  const [gridRows, setGridRows] = useState<any>([]);
  const isfLevel = 'Site';
  const newState = store.getState();
  const [loading, setLoading] = useState<any>(false);

  const headerConfig = {
    headers: {
      sponsor: newState.user.user?.sponsor_sponsor_name,
      site_token: newState.user.user?.siteToken,
      Authorization: `Bearer ${newState.user.user?.sponsorToken}`,
      user_date_time: moment().format()
    }
  };
  const dispatch = useAppDispatch();
  const getData = async () => {
    setLoading(true)
    try {
      const options = {
        endPointEnv: 'etmf',
        pathVariables: {
          // countryId: sitestudypersonnelData.site.site_country,
          // siteId: sitestudypersonnelData.site.site_id,
          // studyId: sitestudypersonnelData.site.study_id,
         milestone: selectedMilestone.minor_milestone
        }
      };     
      const res2 = await axios.get(
        `${apiConfig.appConfig.apiisf}/masterDocument/getAll?application=CTMS&country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=Site&is_binder_view=false&isf_doc_milestone=${selectedMilestone.minor_milestone}&originally_uploaded=false&user_based_details=false&limit=200&module_section_related=Milestones`
      );      
      const associatedDocsISF = res2?.data?.selected_data?.map((doc: any) => {
        return {
          artifact_name: doc.document_data?.isf_artifact_name,
          document_name: doc.document_data?.isf_document_name,
          version_number: doc.document_data?.isf_doc_version_number.toFixed(1),
          status: doc.document_data?.isf_doc_status
        };
      });
      setGridRows([...associatedDocsISF]);
    } catch (error: any) {
      if (error.response.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error.response.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    setLoading(false)
  };

  useEffect(() => {
   
    getData();
    
  }, []);

  if (loading)
  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme: { zIndex: { drawer: number } }) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress />
      </Backdrop>
    </>
  );
  
  return (
    <div className="associated-docs-page">
      <Grid container className="associated-docs-list">
        <Grid md={12}>
          <TableContainer className="associated-docs-table">
            <Table aria-label="collapsible table" >
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Artifact Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Document Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Version number</b>
                  </TableCell>
                  <TableCell>
                    <b>Status</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {gridRows.length ? (
                  gridRows.map((row: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell>{row.artifact_name}</TableCell>
                      <TableCell>{row.document_name}</TableCell>
                      <TableCell>{row.version_number}</TableCell>
                      <TableCell>{row.status}</TableCell>
                    </TableRow>                    
                  ))
                ) : (
                  <TableRow key={1}>
                    <TableCell colSpan={4}>No associated documents found for selected milestone</TableCell>
                  </TableRow>
                )}                
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
};

export default memo(AssociatedDocuments);
